import { locales } from '@americanexpress/conditional-features';

const {
  EN_US,
  JA_JP,
  DE_DE,
  EN_IN,
} = locales;

export const hasCruisesRule = [EN_US];
export const hasNoPackagesRule = [JA_JP, DE_DE, EN_IN, EN_US];
export const hasVacationRentalsRule = [EN_US];
